import './sign-up-free.css';

import './img/sign-up-free.jpg';
import './img/sign-up-free-min.jpg';
import './img/sign-up-free-mobile.jpg';
